<div class="content-header">
    <app-breadcrumb [hidden]="hideBreadcrumb"></app-breadcrumb>
</div>
